import graphqlClient from "../utils/graphql_client_util";
import { SessionStorageUtil } from "../utils/session_storage_util";

const MUTATIONS = {
  REGISTER_SUB_SALES_MAN: `
    mutation RegisterSubSalesMan($input: RegisterSalesManInput!) {
      registerSubSalesMan(
        input: $input
      ) {
        success
        error {
          code
          errorType
          message
        }
        data {
          modDate
          regDate
          salesManCode
          salesManCommission
          salesManDuration
          salesManId
          salesManMarketionCommission
          salesManName
          salesManPhone
          salesManSeq
          salesManStatus
          subSalesManSeq
        }
      }
    }
  `,
};

const QUERIES = {
  GET_SUB_SALES_MAN_BY_CODE: `
    query GetSubSalesManByCode($salesManCode: String!) {
      getSubSalesManByCode(salesManCode: $salesManCode) {
        success
        error {
          code
          errorType
          message
        }
        data {
          salesManStatus
        }
      }
    }
  `,
};

export const registerSubSalesMan = async (
  salesManCode = "",
  salesManId = "",
  salesManName = ""
) => {
  try {
    let params = {
      salesManCode,
      salesManId,
      salesManName,
      salesManPhone: SessionStorageUtil.getItem("phoneNumber"),
    };

    const data = await graphqlClient.mutation(
      MUTATIONS.REGISTER_SUB_SALES_MAN,
      {
        input: params,
      },
      { useAuth: true }
    );

    if (data.registerSubSalesMan.success) {
      return {
        success: true,
        data: data.registerSubSalesMan.data,
      };
    } else {
      return {
        success: false,
        error: data.registerSubSalesMan.error,
      };
    }
  } catch (err) {
    console.error(err);

    return {};
  }
};

export const getSubSalesManByCode = async (salesManCode) => {
  try {
    const data = await graphqlClient.query(QUERIES.GET_SUB_SALES_MAN_BY_CODE, {
      salesManCode: salesManCode,
    });

    if (data.getSubSalesManByCode.success) {
      return {
        success: true,
        data: data.getSubSalesManByCode.data,
      };
    } else {
      return {
        success: false,
        error: data.getSubSalesManByCode.error,
      };
    }
  } catch (err) {
    console.error(err);

    return {};
  }
};
